import type { ExperimentChecker } from "./ExperimentChecker";
import { checkExperimentBase } from "./ExperimentChecker";
import { fluentExperiments } from "./fluentExperiments";

export const isV9RibbonButtonEnabled = (appContext: ExperimentChecker) => {
  return checkExperimentBase(
    appContext,
    fluentExperiments.fluentV9RibbonButtonIsEnabled
  );
};
